module.exports = __webpack_public_path__ + "static/media/Fruity.c5577661.png";